import * as Yup from "yup";

export const validationSchema = Yup.object({
  name: Yup.string().required("Category name is required!"),
  is_active: Yup.string().required("Status is required!"),
});
